import { render } from "./black-list.vue?vue&type=template&id=5b183a0e&scoped=true"
import script from "./black-list.vue?vue&type=script&lang=js"
export * from "./black-list.vue?vue&type=script&lang=js"

import "./black-list.vue?vue&type=style&index=0&id=5b183a0e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b183a0e"]])

export default __exports__